// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Security: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50.7 60"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" focusable="false" width="24" height="24" fill="currentColor"><path d="M25.3 58.4c-.8 0-1.4-.6-1.4-1.4V3.4C11.8 3.9 5.1 10 3.6 11.6v17.3c0 5.7 2.4 16.6 18.6 25.2.7.4.9 1.2.6 1.9-.4.7-1.2.9-1.9.6C14.9 53.4.8 44.3.8 29V11c0-.3.1-.6.3-.9.3-.4 8-9.5 24.1-9.5.8 0 1.4.6 1.4 1.4v52.8C32 52.2 47 43.5 47 28.6V11.4c-1.4-1.4-7.3-6.9-18-7.9-.8-.1-1.3-.8-1.2-1.5.1-.8.8-1.3 1.5-1.2C42.7 2.1 49.1 9.7 49.4 10c.2.2.3.6.3.9v17.7c0 8.3-4.2 16-12 22.4-5 4.1-10 6.3-11.5 7-.2.2-.5.4-.9.4z"/></svg>;
};

export default React.memo(Security);
